// src/utils/session.js
let timeout;
const DEFAULT_TIMEOUT = 15 * 60 * 1000; // Default timeout: 15 minutes

// Get the session timeout from localStorage, or use default
function getSessionTimeout() {
    const sessionTimeout = localStorage.getItem('sessionTimeout');
    return sessionTimeout ? parseInt(sessionTimeout, 10) * 60 * 1000 : DEFAULT_TIMEOUT;
}

// Start the timer
function startTimer(onTimeout) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
        onTimeout();
    }, getSessionTimeout()); // Use dynamic session timeout
}

// Reset the timer on user activity
function resetTimer(onTimeout) {
    startTimer(onTimeout);
}

// Stop the timer (e.g., on logout)
function stopTimer() {
    clearTimeout(timeout);
}

export default {
    startTimer,
    resetTimer,
    stopTimer,
};
